import React, {useState} from 'react'
import PropTypes from 'prop-types'
import Carret from './carret.svg.js'
import style from './style.module.scss'
export const DropDown = (props) => {
    const listCopy = [...props.list]
    const [clicked, setClicked] = useState(false)
    const [value, setValue] = useState(listCopy.shift().id)
    const [selectedLabel, setSelectedLabel] = useState(props.selected.label)
    const handleOpenOptions = (e) => {
        setClicked(true)
    }
    const handleSelectOption = (e) => {
        props.onChange(e.currentTarget.dataset.value)
        let newLabel = props.list.filter(item => {
            return item.id == e.currentTarget.dataset.value
        })
        setSelectedLabel(newLabel.shift().label)
        setClicked(false)
    }
    return (
        <div className={style.main}>
            <div className={style.dropdown} style={props.customStyle}>
                <div className={style.box} onClick={handleOpenOptions}>
                    <div className={style.label}>{selectedLabel}</div>
                    <Carret fill='white' />
                </div>
                {clicked?(
                    <div className={style.options}>
                        {props.list.map((item, key) => {
                            return (
                                <div 
                                    className={style.label} 
                                    key={key} 
                                    data-value={item.id}
                                    onClick={handleSelectOption}
                                >
                                    {item.label}
                                </div>
                            )
                        })}
                    </div>
                ):''}
            </div>
        </div>
    )
}

DropDown.propTypes = {
    list: PropTypes.array,
    selected: PropTypes.any,
    onChange: PropTypes.func
}

DropDown.defaultProps = {
    customStyle: {}
}